import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const CustomCursor = () => {
    const [enabled, setEnabled] = useState(false);
    const [hovering, setHovering] = useState(false);
    const x = useMotionValue(-100);
    const y = useMotionValue(-100);
    const ringX = useSpring(x, { stiffness: 260, damping: 24, mass: 0.6 });
    const ringY = useSpring(y, { stiffness: 260, damping: 24, mass: 0.6 });

    useEffect(() => {
        if (!window.matchMedia("(pointer: fine)").matches) return;
        setEnabled(true);
        document.body.classList.add("custom-cursor-on");
        const move = (e) => {
            x.set(e.clientX);
            y.set(e.clientY);
        };
        const over = (e) => {
            setHovering(!!e.target.closest("a, button, input, textarea, [data-hover]"));
        };
        window.addEventListener("mousemove", move);
        window.addEventListener("mouseover", over);
        return () => {
            document.body.classList.remove("custom-cursor-on");
            window.removeEventListener("mousemove", move);
            window.removeEventListener("mouseover", over);
        };
    }, [x, y]);

    if (!enabled) return null;

    return (
        <>
            <motion.div
                data-testid="custom-cursor-dot"
                className="pointer-events-none fixed left-0 top-0 z-[100] h-1.5 w-1.5 rounded-full bg-coffee-dark"
                style={{ x, y, translateX: "-50%", translateY: "-50%" }}
            />
            <motion.div
                data-testid="custom-cursor-ring"
                className="pointer-events-none fixed left-0 top-0 z-[100] rounded-full border border-coffee"
                style={{ x: ringX, y: ringY, translateX: "-50%", translateY: "-50%" }}
                animate={{
                    width: hovering ? 52 : 32,
                    height: hovering ? 52 : 32,
                    opacity: hovering ? 0.9 : 0.55,
                    backgroundColor: hovering ? "rgba(111,78,55,0.08)" : "rgba(111,78,55,0)",
                }}
                transition={{ type: "spring", stiffness: 300, damping: 22 }}
            />
        </>
    );
};
